import React from 'react';
import { cn } from '@/lib/utils.ts';
import Chip from '@/components/ui/Chip.tsx';
import { TagWebDto } from '@/features/dashboard/tags/types/TagWebDto.ts';
import { getReadableTextColorOnWhite } from '@/features/dashboard/tags/types/tagColor.utils.ts';

interface TagChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  tag: Pick<TagWebDto, 'name' | 'color'>;
  onRemove?: () => void;
}

/**
 * Osobny plik tylko dlatego, że barwa idzie z backendu i musi wejść przez
 * `style`; kształt i skala to `Chip`, żeby tag w edytorze był tym samym
 * chipem, który operator zobaczy potem w tabeli.
 *
 * Ramka zostaje w barwie tagu (obrys nie musi trafiać w próg dla tekstu),
 * napis przechodzi przez przyciemnienie do czytelnego na bieli.
 */
const TagChip = ({ tag, onRemove, className, ...props }: TagChipProps) => (
  <Chip
    size="sm"
    label={tag.name}
    onRemove={onRemove}
    className={cn('max-w-full', className)}
    style={{
      borderColor: tag.color,
      color: getReadableTextColorOnWhite(tag.color),
    }}
    {...props}
  />
);

export default TagChip;
